"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accelerator = void 0;
/**
 * Accelerator class. Use this as a base for your PubSub/Notifications/Eventbus.
 */
var Accelerator = /** @class */ (function () {
    function Accelerator() {
        this.subscribers = {};
        this.subscribers = Object.assign({}, {});
    }
    Accelerator.prototype.subscribe = function (event, callback) {
        if (!Array.isArray(this.subscribers[event])) {
            this.subscribers[event] = [];
        }
        this.subscribers[event].push(callback);
    };
    Accelerator.prototype.publish = function (event, data) {
        if (!Array.isArray(this.subscribers[event])) {
            return;
        }
        this.subscribers[event].forEach(function (callback) {
            callback(data);
        });
    };
    /**
     * Check if there are any subscribers.
     */
    Accelerator.prototype.hasSubscribers = function () {
        return Object.keys(this.subscribers).length > 0;
    };
    Accelerator.prototype.hasSubscriber = function (key) {
        return Object.keys(this.subscribers).includes(key);
    };
    Accelerator.prototype.getSubscriberCount = function () {
        return Object.keys(this.subscribers).length;
    };
    /**
     * Removes all subscribers from this PubSub.
     */
    Accelerator.prototype.removeAllSubscribers = function () {
        this.subscribers = {};
    };
    return Accelerator;
}());
exports.Accelerator = Accelerator;
exports.default = Accelerator;
//# sourceMappingURL=Accelerator.js.map